import { createStaticUrl } from '../utils';
import type { ThemePackageT } from '../types';
import Background from './Background';

const Export: ThemePackageT = {
  id: 'gradient',
  title: 'Gradient',
  background: Background,
  preview: {
    idle: createStaticUrl('static/themes/gradient/gradient_theme_idle.jpg'),
    hover: createStaticUrl('static/themes/gradient/gradient_theme_hover.gif'),
  },
};

export default Export;
